import { setUserActivityTimeData } from './actions'
import { AnalyticsActionType } from './constants'

export const getDefaultState = () => ({
    userActivityTime:{},
    allUsersActivityMinutes:{},
    userLoggedInActivity:{},
    userId:'',
    users:[],
    userActivityError: false,
})

export default (state = getDefaultState(), action) => {
    switch (action.type) {
        case AnalyticsActionType.SET_USER_DATA:
            return setUsersData(state, action)
        case AnalyticsActionType.SET_USER_ACTIVITY_TIME:
            return setUserActivityTime(state, action)
        case AnalyticsActionType.SET_ALL_USERS_ACTIVITY_MINUTES:
            return setAllUsersActivityMinutes(state, action)
        case AnalyticsActionType.SET_USER_LOGGED_IN_ACTIVITY:
            return setUserLoggedInActivity(state, action)
        case AnalyticsActionType.SET_USER_ACTIVITY_ERROR:
            return setUserActivityError(state, action)
        default:
            return state
    }
}

const setUserActivityError = (state, action) => {
    return {
        ...state,
        userActivityError: action.data,
    }
   }

const setUsersData = (state, action) => {
    return {
        ...state,
        users: action.data.users
    }
}

const setUserActivityTime = (state, action) => {
    return {
        ...state,
        userActivityTime: action.data,
    }
}

const setAllUsersActivityMinutes = (state, action) => {
    return {
        ...state,
        allUsersActivityMinutes: action.data,
    }
}

const setUserLoggedInActivity = (state, action) => {
    return {
        ...state,
        userLoggedInActivity: action.data,
    }
}



